function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 174.239 174.239"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M74.439 157.519a4.199 4.199 0 01-6.111.313L1.38 94.468a4.447 4.447 0 01-.173-6.267l21.33-22.539a4.447 4.447 0 016.267-.173L65.375 100.1a4.199 4.199 0 006.111-.313l71.447-83.015a4.445 4.445 0 016.251-.468l23.518 20.242a4.446 4.446 0 01.468 6.252L74.439 157.519z"
})));